import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, throwError } from 'rxjs';
import { ImpersonationStore } from 'shared';

import { AuthStore } from '../store/auth.store';

/** The API authenticates the admin with a Secure, HttpOnly cookie session. */
export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const cookieRequest = req.clone({ withCredentials: true });
  const url = req.url.toLowerCase();

  if (
    url.includes('/api/v2/auth/login') ||
    url.includes('/api/v2/auth/logout') ||
    url.includes('/api/v2/auth/register') ||
    url.includes('/api/v2/auth/refresh-token') ||
    url.includes('/api/v2/auth/send-password-reset') ||
    url.includes('/api/v2/auth/reset-password') ||
    url.includes('/api/v2/auth/verify-email') ||
    url.includes('/api/v2/auth/send-verification')
  ) {
    return next(cookieRequest);
  }

  const authStore = inject(AuthStore);
  const router = inject(Router);
  const impersonationStore = inject(ImpersonationStore);

  return next(cookieRequest).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        const wasAuthenticated = authStore.isAuthenticated();
        impersonationStore.clearStorage();
        authStore.logout(false);
        if (wasAuthenticated) {
          void router.navigate(['/auth/session-expired']);
        }
      }
      return throwError(() => error);
    }),
  );
};
